import styled, { keyframes, css } from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;
  margin-left: 5px;
  margin-right: 5px;
`

export const PlanCard = styled.div<{backgroundColor: string}>`
  background-color: ${( props => props.backgroundColor )};
  border-radius: 16px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 2px 8px 0px rgba(19, 26, 45, 0.20);
  margin-bottom: 24px;
  min-width: 230px;
`

export const CardHeader = styled.div<{detailColor: string}>`
  height: 16px;
  width: 100%;
  background-color: ${props => props.detailColor};
  border-radius: 16px 16px 0px 0px;
`

export const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 22px;
`

export const ImageWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: center;
  img {
    height: 64px;
  }
`

export const CardText = styled.div`
  margin-top: 28px;
  text-align: center;
  min-height: 96px;

  color: ${( props ) => props.theme.cores[ 'GREY-700-TXT' ]};
  font-family: ${( props ) => props.theme.fontFamily.notoSans};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 2.5%;
  text-align: center;
`

export const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 206px;
  margin-top: 43px;
`

export const OriginalPrice = styled.div<{textColor: string}>`
  color: ${props => props.textColor};
  height: 24px;

  font-family: ${props => props.theme.fontFamily.notoSans};
  font-weight: 200;
  font-size: 24px;
  line-height: 24px;
  text-decoration: line-through;
`

export const Price = styled.div<{textColor: string}>`
  display: flex;
  align-items: flex-end;

  margin-top: 3px;
  color: ${props => props.textColor};
  font-family: ${props => props.theme.fontFamily.notoSans};
  font-weight: 700;
  font-size: 48px;
  line-height: 48px;
  letter-spacing: -2.5%;
`

export const ByMonth = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
`

export const ShippingCharge = styled.div<{textColor: string}>`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 3px;

  span {
    font-family: ${props => props.theme.fontFamily.notoSans};
    color: ${props => props.textColor};

    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 2.5%;
    text-align: right;
  }
`

export const GiftWrapper = styled.div`
  margin-top: 25px;
  height: 20px;
  min-width: 220px;

  display: flex;
  justify-content: center;
  align-items: center;

  .gatsby-image-wrapper, img {
    width: 17px;
    margin-right: 3px;
  }
`

export const GiftText = styled.div<{textColor: string}>`
  font-family: ${props => props.theme.fontFamily.notoSans};
  color: ${props => props.textColor};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
`

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  20% { transform: translateY(-20px); }
  40% { transform: translateY(0); }
  60% { transform: translateY(-10px); }
  80% { transform: translateY(0); }
`

export const PrimaryCta = styled.a<{backgroundColor: string, bounce?: boolean}>`
  ${props => props.bounce && css`animation: ${bounce} 0.6s;`}

  width: 100%;
  padding: 11px 32px 11px 32px;
  color: #f9f6ef !important;
  background-color: ${props => props.backgroundColor};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  margin-top: 25px;
  min-width: 215px;

  font-family: ${props => props.theme.fontFamily.notoSans};
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 1%;
`

export const SecondaryCta = styled.a<{backgroundColor: string, textColor: string}>`
  width: 100%;
  padding: 11px 32px 11px 32px;
  color: ${props => props.textColor};
  background-color: ${props => props.backgroundColor};;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  margin-top: 3px;
  min-width: 215px;

  font-family: ${props => props.theme.fontFamily.notoSans};
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 1%;
`
